/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * scrollTrigger-splash.js
 *
 * ロード後に実行するアニメーション用
 *
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * 初期設定
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

var body = document.body;
var loading = document.getElementById('loading');
var progress = document.getElementById('progress');

/**
 * set
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
  gsap.set(body, {
    opacity: 0,
  });

/**
 * timeline
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

var tl = gsap.timeline({
  defaults: { duration: 1, ease: "power4.out" },
});

/**
 * to
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * actionToSplash
 * 全ページ用スプラッシュアクション
 */
function actionToSplash() {
  tl.to(body, {
    opacity: 1,
  })
}

/**
 * actionToSplash
 * 初回読み込み用スプラッシュアクション
 */
function actionToFirstSplash() {
  tl.to(loading, {
    autoAlpha: 0,
  })
}

/**
 * actionToSplashHome
 * TOPページ用スプラッシュアクション
 */
function actionToSplashHome() {
  tl.to(body, {
    opacity: 1,
  })
}

/**
 * actionToSplashLower
 * 下層ページ用スプラッシュアクション
 */
function actionToSplashLower() {
  tl.to(body, {
    opacity: 1,
  })
}

/**
 * Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export { actionToSplash };
